<div class="pack-page">

  <!-- ── Breadcrumb ─────────────────────────────────────────────────────────── -->
  <div class="pack-breadcrumb">
    <div class="container">
      <a routerLink="/packges" class="back-link">
        <i class="ti-arrow-left"></i>
        <span>All Packages</span>
      </a>
    </div>
  </div>

  <!-- ── Hero: image + info ─────────────────────────────────────────────────── -->
  <section class="pack-hero">
    <div class="container">
      <div class="row g-4 g-lg-5 align-items-start">

        <!-- Image -->
        <div class="col-md-6">
          <div class="pack-img-frame">
            <img [src]="packImage" [alt]="name" class="pack-main-img" />
            <div class="frame-corner frame-corner--tl"></div>
            <div class="frame-corner frame-corner--br"></div>
          </div>
        </div>

        <!-- Info panel -->
        <div class="col-md-6">
          <div class="pack-info">

            <div class="pack-eyebrow">
              <span class="eyebrow-rule"></span>
              <span class="eyebrow-text">Curated Package</span>
            </div>

            <h1 class="pack-name">{{ name }}</h1>

            <div class="pack-pricing">
              <span class="pack-price">{{ price }} <em>LE</em></span>
              <span *ngIf="discount" class="pack-discount-badge">
                <i class="ti-tag"></i>&nbsp;{{ discount }}% off
              </span>
            </div>

            <div class="pack-rule">
              <span></span>
              <span class="rule-diamond"></span>
              <span></span>
            </div>

            <p class="pack-includes-note">
              <i class="ti-layers"></i>
              Includes <strong>{{ products.length }}</strong> curated products
            </p>

            <button class="pack-cta" (click)="addToCart()">
              <i class="ti-shopping-cart"></i>
              Add Package to Cart
            </button>

          </div>
        </div>

      </div>
    </div>
  </section>

  <!-- ── Products included ──────────────────────────────────────────────────── -->
  <section class="pack-items-section">
    <div class="container">

      <div class="items-heading">
        <div class="items-eyebrow">
          <span class="eyebrow-rule"></span>
          <span class="eyebrow-text">Inside This Package</span>
          <span class="eyebrow-rule"></span>
        </div>
        <h2 class="items-title">What's Included</h2>
      </div>

      <div class="row g-3 justify-content-center">
        <div class="col-6 col-md-4 col-lg-3" *ngFor="let item of products">
          <div class="item-card">
            <div class="item-img-wrap">
              <img [src]="item.imagePath" [alt]="item.products.name" />
              <span class="item-qty-badge">×{{ item.amount }}</span>
            </div>
            <div class="item-info">
              <h5 class="item-name">{{ item.products.name }}</h5>
              <p class="item-qty">Qty: {{ item.amount }}</p>
            </div>
          </div>
        </div>
      </div>

      <div class="items-cta-row">
        <button class="pack-cta" (click)="addToCart()">
          <i class="ti-shopping-cart"></i>
          Add Package to Cart &nbsp;&mdash;&nbsp; {{ price }} LE
        </button>
      </div>

    </div>
  </section>

</div>
